// @flow
import React, { PureComponent } from 'react';
import { Source, Layer } from 'react-mapbox-gl';

import MapContext from 'components/Map/MapContext';
import { isFeatureDisabled } from 'utils/auth';

import type { Feature2D } from 'flow-geojson';

type Props = {
  hasSubscription: boolean,
};

type State = {
  zoom: number,
  gridFeatures: Array<Feature2D>,
};

const fmod = (a, b) => Number((a - Math.floor(a / b) * b).toPrecision(8));

const ARCSEC = 1 / 3600;
const GRID_MINZOOM = 15;

export default class ArcSecondGrid extends PureComponent<Props, State> {
  _map: any;
  _sourceRef: any;
  _index: KDBush;

  state: State = {
    zoom: 0,
    gridFeatures: [],
  };

  _updateGridData() {
    const source = this._map.getSource('arcsecond-grid-source');

    if (!source) {
      return;
    }

    source.setData({ type: 'FeatureCollection', features: [] });

    const zoom = this._map.getZoom();
    const bounds = this._map.getBounds().toArray();

    if (zoom >= GRID_MINZOOM) {
      const lonOrigin = bounds[0][0] - fmod(bounds[0][0], ARCSEC);
      const latOrigin = bounds[0][1] - fmod(bounds[0][1], ARCSEC);

      const lonSize = (bounds[1][0] - lonOrigin) / ARCSEC;
      const latSize = (bounds[1][1] - latOrigin) / ARCSEC;

      const gridFeatures = new Array(Math.ceil(lonSize))
        .fill(0)
        .reduce(
          (agg, _, i) => [
            ...agg,
            Array.from({ length: Math.ceil(latSize) }, (__, j) => ({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [lonOrigin + i * ARCSEC, latOrigin + j * ARCSEC],
              },
            })),
          ],
          []
        )
        .flat();

      setTimeout(() => {
        source.setData({
          type: 'FeatureCollection',
          features: gridFeatures,
        });
        this._map.fire('arcsecond-grid-updated');
      }, 100);
    }
  }

  render() {
    const { hasSubscription } = this.props;

    if (hasSubscription && isFeatureDisabled('degree_second_grid')) {
      return null;
    }

    return (
      <MapContext.Consumer>
        {map => {
          if (map && !this._map) {
            this._map = map;
            this._map.on('moveend', () => {
              this._updateGridData();
            });
            this._updateGridData();
            this._map.triggerRepaint();
          }

          return [
            <Source
              key="arcsecond-grid-source"
              id="arcsecond-grid-source"
              geoJsonSource={{
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features: [],
                },
              }}
            />,
            <Layer
              key="arcsecond-grid-layer"
              id="arcsecond-grid-layer"
              sourceId="arcsecond-grid-source"
              type="circle"
              paint={{
                'circle-color': 'rgba(0, 0, 0, .25)',
                'circle-radius': 2,
              }}
            />,
          ];
        }}
      </MapContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Map/ArcSecondGrid.js